import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getUser, getToken } from "../auth/auth";
import { useTranslation } from "react-i18next"; 

const TopMenu = () => {
    const token = getToken();
    const user = getUser();
    const { t } = useTranslation(); 
    
    // ستيت للتحكم في القوائم
    const [open, setOpen] = useState(false); // قائمة الموبايل
    const [isAdminOpen, setIsAdminOpen] = useState(false); // قائمة الآدمن

    // 👇 السحر هنا: قفل كل القوائم أوتوماتيك مع تغيير الرابط أو الرجوع
    const location = useLocation();
    useEffect(() => {
        setOpen(false);
        setIsAdminOpen(false);
    }, [location.pathname]);

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark p-0 shadow-sm">
            <div className="container-fluid">
                <button
                    className="navbar-toggler my-2"
                    type="button"
                    onClick={() => setOpen(!open)}
                >
                    <span className="navbar-toggler-icon" />
                </button>

                <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
                    <ul className="navbar-nav mx-auto">
                        <li className="nav-item">
                            <Link className="nav-link px-3" to="/" onClick={() => setOpen(false)}>{t("nav_home")}</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link px-3" to="/products" onClick={() => setOpen(false)}>{t("nav_products")}</Link>
                        </li>

                        {/* قائمة الإدارة */}
                        {token && user?.role === "admin" && (
                            <li className="nav-item dropdown position-relative">
                                <button
                                    className="btn nav-link dropdown-toggle fw-bold text-warning px-3 border-0 bg-transparent"
                                    onClick={() => setIsAdminOpen(!isAdminOpen)}
                                >
                                    <i className="bi bi-shield-lock me-1"></i> {t("nav_admin")}
                                </button>
                                
                                <ul 
                                    className={`dropdown-menu shadow-sm text-start ${isAdminOpen ? 'show' : ''}`}
                                    style={{ position: 'absolute', top: '100%', right: '0', zIndex: 1050 }}
                                >
                                    <li><Link className="dropdown-item" to="/admin/dashboard" onClick={() => setIsAdminOpen(false)}>{t("nav_admin_dash")}</Link></li>
                                    <li><Link className="dropdown-item" to="/admin/categories" onClick={() => setIsAdminOpen(false)}>{t("nav_admin_cats")}</Link></li>
                                    <li><Link className="dropdown-item" to="/admin/products" onClick={() => setIsAdminOpen(false)}>{t("nav_admin_prods")}</Link></li>
                                    <li><Link className="dropdown-item" to="/admin/orders" onClick={() => setIsAdminOpen(false)}>{t("nav_admin_orders")}</Link></li>
                                </ul>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default TopMenu;